// extracted by mini-css-extract-plugin
module.exports = {"purchase":"successPurchase_purchase__1MAEn","iconCheck":"successPurchase_iconCheck__Sf9Th","info":"successPurchase_info__1IcSI"};